/**
 * Opens an HTMLDialogElement by its id.
 * @param id The id of the HTMLDialogElement to open.
 */ export const openDialogById = (id)=>{
    const dialog = getDialogById(id);
    if (!dialog.open) {
        dialog.showModal();
    } else {
        console.warn(`Dialog with id: ${id} is already open.`);
    }
};
/**
 * Closes an HTMLDialogElement by its id.
 * @param id The id of the HTMLDialogElement to close.
 */ export const closeDialogById = (id)=>{
    const dialog = getDialogById(id);
    if (dialog.open) {
        dialog.close();
    } else {
        console.warn(`Dialog with id: ${id} is already closed.`);
    }
};
/**
 * Retrieves an HTMLDialogElement by its id.
 * @param id The id of the HTMLDialogElement to retrieve.
 * @returns The HTMLDialogElement with the specified id.
 * @throws Error if no element is found with the given id or if the element is not an HTMLDialogElement.
 */ export const getDialogById = (id)=>{
    const dialog = document.getElementById(id);
    if (!dialog) throw new Error(`No dialog found with id: ${id}`);
    if (!isHTMLDialogElement(dialog)) throw new Error(`Element with id: ${id} is not an HTMLDialogElement`);
    return dialog;
};
/**
 * Creates a toggle handler for an HTMLDialogElement with the given id.
 * @param id The id of the HTMLDialogElement to toggle.
 * @returns A function that toggles the dialog's open state.
 */ export const createDialogToggler = (id)=>()=>{
        const dialog = getDialogById(id);
        if (dialog.open) {
            dialog.close();
        } else {
            dialog.showModal();
        }
    };
/**
 * Type predicate to check if an element is an HTMLDialogElement.
 * @param element The element to check.
 * @returns True if the element is an HTMLDialogElement, false otherwise.
 */ export function isHTMLDialogElement(element) {
    return element.tagName === 'DIALOG';
}
